export const BreakdownByTenureStyles = {
  estimationTable: {
    marginTop: "24px",
    "& .MuiToolbar-root": {
      display: "none"
    }
  },
  subTitle: {
    fontSize: "20px",
    marginTop: "24px",
    marginBottom: "16px",
    marginLeft: "0px"
  },
  tenureTable: {
    "& .MuiPaper-root": {
      boxShadow: "none",
      border: "1px solid #e0e0e0",
      borderRadius: "8px"
    },
    "& .MuiTableHead-root": {
      backgroundColor: "#f5f5f5"
    },
    "& .MuiTableCell-head": {
      fontSize: "12px",
      fontWeight: "600",
      color: "#2e2f32",
      padding: "12px 16px"
    },
    "& .MuiTableCell-body": {
      fontSize: "14px",
      color: "#2e2f32",
      padding: "12px 16px"
    },
    "& .MuiTableRow-root:hover": {
      backgroundColor: "#f9f9f9"
    },
    "& .MuiTableContainer-root": {
      overflow: "visible"
    },
    "& .MuiTable-root": {
      overflow: "visible"
    },
    "& .MuiTableCell-root": {
      overflow: "visible !important",
      whiteSpace: "nowrap"
    },
    "& [class*='MUIDataTableBodyCell-root']": {
      overflow: "visible !important"
    },
    "& [class*='tss-'][class*='MUIDataTableBodyCell-root']": {
      overflow: "visible !important"
    }
  },
  hideScrollbars: {
    /* Hide scrollbars for webkit browsers */
    "&::-webkit-scrollbar": {
      display: "none"
    },
    /* Hide scrollbars for Firefox */
    scrollbarWidth: "none",
    /* Hide scrollbars for IE and Edge */
    "-ms-overflow-style": "none",
    /* General overflow handling */
    overflow: "visible"
  },
  actionButton: {
    minWidth: "auto",
    padding: "4px 8px"
  }
};